import { CancelRecurrenceResponse } from 'services/DebinServices'
import { DebinActionTypes, DebinMovement, Recurrence } from './types'

export const getRecurrencesPending = () => ({
  type: DebinActionTypes.GET_RECURRENCES_PENDING
})

export const getRecurrencesFulfilled = (data: Recurrence[]) => ({
  type: DebinActionTypes.GET_RECURRENCES_FULFILLED,
  payload: data
})

export const getRecurrencesRejected = () => ({
  type: DebinActionTypes.GET_RECURRENCES_REJECTED
})

export const confirmRecurrencePending = () => ({
  type: DebinActionTypes.CONFIRM_RECURRENCE_PENDING
})

export const confirmRecurrenceFulfilled = (data: Recurrence) => ({
  type: DebinActionTypes.CONFIRM_RECURRENCE_FULFILLED,
  payload: data
})

export const confirmRecurrenceRejected = () => ({
  type: DebinActionTypes.CONFIRM_RECURRENCE_REJECTED
})

export const cancelRecurrencePending = () => ({
  type: DebinActionTypes.CANCEL_RECURRENCE_PENDING
})

export const cancelRecurrenceFulfilled = (data: CancelRecurrenceResponse) => ({
  type: DebinActionTypes.CANCEL_RECURRENCE_FULFILLED,
  payload: data
})

export const cancelRecurrenceRejected = () => ({
  type: DebinActionTypes.CANCEL_RECURRENCE_REJECTED
})

export const getDebinMovementsPending = () => ({
  type: DebinActionTypes.GET_DEBIN_MOVEMENTS_PENDING
})

export const getDebinMovementsFulfilled = (data: DebinMovement[]) => ({
  type: DebinActionTypes.GET_DEBIN_MOVEMENTS_FULFILLED,
  payload: data
})

export const getDebinMovementsRejected = () => ({
  type: DebinActionTypes.GET_DEBIN_MOVEMENTS_REJECTED
})
